export default "__VITE_ASSET__3ab16bc5__"